<template>
	<div class="order_detail">
		<div class="progress d-flex flex-column j-sb a-start">
			<div class="w-100 d-flex j-sb a-center"
				style="padding: 0 1.38rem;font-size: 0.88rem;box-sizing: border-box;">
				<div class="d-flex jc-center a-center"
					:style="orders.order_status == 100?'background: #1E69FF;box-shadow: 0px 10px 9px 0px rgba(30, 105, 255, 0.3);border: 2px solid #FFFFFF;':'background: #A3C2FF;'"
					style="width: 9.5rem;height: 2.38rem;box-sizing: border-box;line-height: 2.38rem;color: #FFFFFF;border-radius: 1.19rem;text-align: center;">
					<img v-if="orders.order_status == 100" src="../../../assets/order/xuanzhong@2x.png" alt=""
						style="width: 1.19rem;height: 1.19rem;margin-right: 0.63rem;">
					<span>提交订单</span>
				</div>
				<img :src="0?require('../../../assets/order/youse@2x.png') :require('../../../assets/order/wuse@2x.png')"
					alt="" style="width: 1.38rem;height: 1.38rem;">
				<div class="d-flex jc-center a-center"
					:style="orders.order_status == 101?'background: #1E69FF;box-shadow: 0px 10px 9px 0px rgba(30, 105, 255, 0.3);border: 2px solid #FFFFFF;':'background: #A3C2FF;'"
					style="width: 9.5rem;height: 2.38rem;box-sizing: border-box;line-height: 2.38rem;color: #FFFFFF;border-radius: 1.19rem;text-align: center;">
					<img v-if="orders.order_status == 101" src="../../../assets/order/xuanzhong@2x.png" alt=""
						style="width: 1.19rem;height: 1.19rem;margin-right: 0.63rem;">
					<span>支付订单</span>
				</div>
				<img :src="0?require('../../../assets/order/youse@2x.png') :require('../../../assets/order/wuse@2x.png')"
					alt="" style="width: 1.38rem;height: 1.38rem;">
				<div class="d-flex jc-center a-center"
					:style="orders.order_status == 6||orders.order_status == 104?'background: #1E69FF;box-shadow: 0px 10px 9px 0px rgba(30, 105, 255, 0.3);border: 2px solid #FFFFFF;':'background: #A3C2FF;'"
					style="width: 9.5rem;height: 2.38rem;box-sizing: border-box;line-height: 2.38rem;color: #FFFFFF;border-radius: 1.19rem;text-align: center;">
					<img v-if="orders.order_status == 6 ||orders.order_status == 104" src="../../../assets/order/xuanzhong@2x.png" alt=""
						style="width: 1.19rem;height: 1.19rem;margin-right: 0.63rem;">
					<span>商家发货</span>
				</div>
				<img :src="0?require('../../../assets/order/youse@2x.png') :require('../../../assets/order/wuse@2x.png')"
					alt="" style="width: 1.38rem;height: 1.38rem;">
				<div class="d-flex jc-center a-center"
					:style="orders.order_status == 102?'background: #1E69FF;box-shadow: 0px 10px 9px 0px rgba(30, 105, 255, 0.3);border: 2px solid #FFFFFF;':'background: #A3C2FF;'"
					style="width: 9.5rem;height: 2.38rem;box-sizing: border-box; line-height: 2.38rem;color: #FFFFFF;border-radius: 1.19rem;text-align: center;">
					<img v-if="orders.order_status == 102" src="../../../assets/order/xuanzhong@2x.png" alt=""
						style="width: 1.19rem;height: 1.19rem;margin-right: 0.63rem;">
					<span>确认收货</span>
				</div>
				<img :src="0?require('../../../assets/order/youse@2x.png') :require('../../../assets/order/wuse@2x.png')"
					alt="" style="width: 1.38rem;height: 1.38rem;">
				<div class="d-flex jc-center a-center"
					:style="orders.order_status == 105?'background: #1E69FF;box-shadow: 0px 10px 9px 0px rgba(30, 105, 255, 0.3);border: 2px solid #FFFFFF;':'background: #A3C2FF;'"
					style="width: 9.5rem;height: 2.38rem;box-sizing: border-box;line-height: 2.38rem;color: #FFFFFF;border-radius: 1.19rem;text-align: center;">
					<img v-if="orders.order_status == 105" src="../../../assets/order/xuanzhong@2x.png" alt=""
						style="width: 1.19rem;height: 1.19rem;margin-right: 0.63rem;">
					<span>评价</span>
				</div>
			</div>
			<div class="devider"></div>
			<span style="font-size: 0.75rem;font-weight: bold; padding: 0 1.75rem;">{{orders.add_time}}</span>
		</div>
		<div class="order_info position-relative d-flex flex-column j-sb a-start">
			<header class="w-100 d-flex j-sb a-center">
				<div class="label" style="font-size: 0.88rem;">
					{{getState}}
				</div>
				<div class="shadow"></div>
				<span @click="openView" style="font-size: 0.75rem;margin:1rem 1.25rem 0 0;cursor: pointer;">订单所属门店：
					<span style="color: #666666;">{{orders.store_name}}<i class="el-icon-arrow-right"></i></span>
				</span>
			</header>
			<div class="flex-1 d-flex flex-column j-sb a-start" style="margin-top: 3.09rem;">
				<div
					style="width: 12.33rem;text-align: center;border-bottom: 0.19rem solid #1E69FF;color:#1E69FF; font-size: 0.94rem;">
					订单信息
				</div>
				<div class="flex-1" style="padding: 1.19rem 1.94rem;font-size: 0.75rem;color: #666666;">
					<span>买家信息</span>
					<div class="h-100 d-flex flex-column flex-wrap j-start a-start"
						style="padding-top: 1.94rem;box-sizing: border-box;">
						<span style="height: 20%;padding: 0 2rem 0 0;">用户昵称：{{orders.nick_name}}</span>
						<span style="height: 20%;padding: 0 2rem 0 0;">联系电话：{{orders.mobile}}</span>
						<span style="height: 20%;padding: 0 2rem 0 0;">收货人姓名：{{orders.consignee}}</span>
						<span style="height: 20%;padding: 0 2rem 0 0;">
							收货人地址：{{orders.province_name}}/{{orders.city_name}}/{{orders.district_name}}/{{orders.address}}
						</span>
						<span style="height: 20%;padding: 0 2rem 0 0;">备注留言：{{orders.postscript}}</span>
						<span style="height: 20%;padding: 0 2rem 0 0;">订单编号：{{orders.order_sn}}</span>
						<span style="height: 20%;padding: 0 2rem 0 0;">下单时间：{{orders.add_time}}</span>
						<span v-if="status>1" style="height: 20%;padding: 0 2rem 0 0;">支付时间：{{orders.pay_time}}</span>
						<span style="height: 20%;padding: 0 2rem 0 0;">发票类型：
						{{orders.inv_payee==0?'不需要发票':orders.inv_payee==1?'普通发票':'增值发票'}}</span>
					</div>
				</div>
			</div>
		</div>
		<table class="item_info" style="font-size: 0.75rem;font-weight: bold;">
			<tr class="head">
				<th>商品信息</th>
				<th>订单状态</th>
				<th>单价</th>
				<th>数量</th>
				<th>规格属性</th>
			</tr>
			<tr style="text-align: center;color: #666666;" v-for="(item,index) in orderList" :key="index">
				<td style="width: 30%;">
					<div class="d-flex j-center a-start">
						<img :src="item.goods_thumb" alt="" style="width: 2.8rem;height: 2.8rem;">
						<span
						style="display: -webkit-box;overflow: hidden; text-overflow: ellipsis;line-clamp: 2;
						-webkit-box-orient: vertical;line-height: 1;width: 13.75rem;">{{item.goods_name}}</span>
					</div>
				</td>
				<td style="width: 15%;">{{getState}}</td>
				<td style="width: 15%;">￥{{item.goods_price}}</td>
				<td style="width: 15%;">{{item.goods_number}}</td>
				<td style="width: 25%;">{{item.goods_attr||'标配'}}</td>
			</tr>
		</table>
		<div class="amount d-flex j-end a-center">
			<div style="padding: 0 1.25rem;font-size: 0.75rem;font-weight: bold;">满减优惠：<span
					style="color: #666666;">-￥{{orders.dis_amount}}</span></div>
			<div style="padding: 0 1.25rem;font-size: 0.75rem;font-weight: bold;">优惠券优惠：<span
					style="color: #666666;">-￥{{orders.coupons}}</span></div>
			<div style="padding: 0 1.25rem;font-size: 0.75rem;font-weight: bold;">商家改价：<span
					style="color: #666666;">-￥{{orders.change_amount}}</span></div>
			<div style="padding: 0 1.25rem;font-size: 0.75rem;font-weight: bold;">运费：<span
					style="color: #666666;">￥{{orders.shipping_fee}}</span></div>
			<!-- <div v-if="status==1" style="padding: 0 1.25rem;font-size: 0.75rem;font-weight: bold;">实际应付款：<span
					style="color: #FF4343;">￥{{actual_price.toFixed(2)}}元</span></div> -->
			<div  style="padding: 0 1.25rem;font-size: 0.75rem;font-weight: bold;">实际付款：<span
					style="color: #FF4343;">￥{{orders.order_amount}}元</span></div>
		</div>
		<div class="cancel_bar d-flex j-center a-center" v-if="status==1" style="font-weight: bold;font-size: 0.75rem;">
			{{min}}分{{sec}}秒后自动取消
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
				orders:'',
				orderList:[]
			}
		},
		mounted() {
			this.order_info()
		},
		computed: {
			getState(){
				let sta = this.orders.order_status
				let str =  sta == 100 ?'待付款':sta == 101?'待发货':sta == 6?'待取货':sta==2?'已取消':sta==102?'已完成':sta==104?'待收货':'待评价'
				return str
			}
		},
		methods: {
			order_info(){				
				let params = {
					act:'order_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					order_id:this.$route.query.id
				}
				
				this.$api.order_info(params).then((res)=>{
					if(res.code == 0){
						this.orders = res.data.order_list
						this.orderList = res.data.goods_list
					}
					
				})
			},
			openView(row){
				this.$router.push({
						name: 'shop_detail',
						params: {
							id: this.$route.query.atid
						}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@mixin common {
		background: #FFFFFF;
		border-radius: 6px;
		margin-top: 1.25rem;
	}

	.order_detail {
		max-width: 73.24rem;
		margin: 0 auto;

		.progress {
			@include common;
			margin-top: 0;
			width: 100%;
			height: 10rem;
			padding: 1.78rem 0;
			box-sizing: border-box;

			.devider {
				width: 73.13rem;
				height: 0.47rem;
				background: linear-gradient(90deg, #F8F8F8 0%, #1E69FF 100%);
				border-radius: 6px;
			}
		}

		.order_info {
			@include common;
			width: 100%;
			height: 21.63rem;

			.label {
				background: #FF9C00;
				width: 7.88rem;
				height: 2.31rem;
				line-height: 2.31rem;
				text-align: center;
				padding-right: 1.576rem;
				box-sizing: border-box;
				color: #FFFFFF;
				position: relative;
				border-radius: 6px 0 0 0;
				z-index: 999;
				clip-path: polygon(0 0, 100% 0, 80% 100%, 0 100%);
			}

			.shadow {
				background: #FAD294;
				width: 7.88rem;
				height: 2.31rem;
				color: #FFFFFF;
				position: absolute;
				left: 4px;
				top: -2px;
				border-radius: 6px 0 0 0;
				z-index: 998;
				clip-path: polygon(0 0, 100% 0, 80% 100%, 0 100%);
			}
		}

		.item_info {
			@include common;
			width: 100%;
			height: 9.38rem;
			padding: 1.5rem 2rem;
			box-sizing: border-box;
		}

		.amount {
			@include common;
			height: 3.75rem;
		}

		.cancel_bar {
			@include common;
			height: 3.75rem;
			color: #FF3333;
		}
	}
</style>
